export default {
    loading: false,
    online: true
}